import React from "react";
import { Container, Box, Typography } from "@mui/material";
import Contact from "../components/Contact/Contact";

const ContactPage = () => {
  return (
    <Box sx={{ pt: 4 }}>
      <Container maxWidth="lg">
        <Box sx={{ py: 4 }}>
          <Typography
            variant="h1"
            sx={{
              mb: 1,
              fontSize: { xs: "2.4rem", md: "3.5rem" },
              background: "linear-gradient(135deg, #2563eb, #7c3aed)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Get In Touch
          </Typography>
          <Typography color="text.secondary" sx={{ maxWidth: 760 }}>
            Reach me for software roles, frontend roles, technical support
            opportunities, and carefully selected freelance work.
          </Typography>
        </Box>

        <Contact />
      </Container>
    </Box>
  );
};

export default ContactPage;
